import { format } from "date-fns";

/**
 * Date情報から日本語の曜日を取得
 * @param {Date} date
 */
export const get曜日 = (date) =>
  ["日", "月", "火", "水", "木", "金", "土"][date.getDay()];

/**
 * M月D日(曜日)のフォーマットで日付を取得
 * @param {Date} date
 */
export const get日付 = (date) => format(date, `M月d日(${get曜日(date)})`);

const wareki = [
  { name: "令和", start: "2019/05/01", diff: 2018 },
  { name: "平成", start: "1989/01/08", diff: 1988 },
  { name: "昭和", start: "1926/12/25", diff: 1925 },
  { name: "大正", start: "1912/07/30", diff: 1911 },
  { name: "明治", start: "1868/10/23", diff: 1867 },
];

/**
 * 年換算の和暦取得
 * @param {Date} date
 */
export const getWarekiForYear = (date) => {
  const year = date.getFullYear();

  const needle = wareki.find(
    (row) => date.getFullYear() >= new Date(row.start).getFullYear()
  );

  const toWareki = (needle) => `${needle.name + toWarekiYear(needle)}年`;

  const toWarekiYear = (needle) =>
    year - needle.diff === 1 ? "元" : year - needle.diff;

  if (needle) return toWareki(needle);
  else return `${year}年`;
};

/**
 * 月換算の和暦取得
 * @param {Date} date
 */
export const getWarekiForMonth = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;

  const needle = wareki.find((row) => date >= new Date(row.start));

  const toWareki = (needle) =>
    `${needle.name + toWarekiYear(needle)}年${month}月`;

  const toWarekiYear = (needle) =>
    year - needle.diff === 1 ? "元" : year - needle.diff;

  if (needle) return toWareki(needle);
  else return `${year}年${month}月`;
};
